<script>
    import AddSpecialDay from "./AddSpecialDay.svelte";
    import NewSpecialDay from "./NewSpecialDay.svelte";
    import SpecialDay from "./SpecialDay.svelte";
    import { deleteField } from "firebase/firestore";


    export let specialDays;
    specialDays = specialDays??{};

    function add(e) {
        const date = e.detail.date;
        console.log(date);
        specialDays[date] = {
            year: e.detail.year,
            periods: e.detail.periods
        }
    }

    function remove(e) {
        const date = e.detail.date;
        console.log(date);
        delete specialDays[date];
        specialDays = specialDays;
    }
</script>

{#each Object.entries(specialDays) as [date, specialDay] (date)}
    <SpecialDay day={0} bind:date={date} bind:year={specialDay.year} bind:periods={specialDay.periods} on:remove={remove}/>
{/each}
<!-- <AddSpecialDay on:add={add}/> -->
<NewSpecialDay on:add={add}/>

<style>

</style>